import { render, staticRenderFns } from "./coursePage.vue?vue&type=template&id=352805aa&scoped=true&"
import script from "./coursePage.vue?vue&type=script&lang=ts&"
export * from "./coursePage.vue?vue&type=script&lang=ts&"
import style0 from "./coursePage.vue?vue&type=style&index=0&id=352805aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352805aa",
  null
  
)

export default component.exports